import React from 'react';
import classNames from 'classnames';
import Lottie from 'lottie-react';

import { PaddingContainer, WidthContainer } from '@components';
import ArrowRight from '@images/icons/arrow-right.svg';
import {
	canBeAppliedForData,
	technologies,
} from '@store/LocationAssetsTrackingData';
import canBeAppliedForAnimation from '@images/animations/canBeAppliedForAnimation.json';

import * as styles from './AssetTracking.module.scss';

export const AssetTracking: React.FC = () => {
	return (
		<PaddingContainer className="white-bg">
			<WidthContainer>
				<h2 className="font-size-medium-title mb-2">Custom Asset Tracking</h2>
				<p className={classNames(styles.description, 'font-size-sm')}>
					EMBIQ delivers innovative solutions for various options for tracking.
					Integrated with sensors lets for remote monitoring of assets and
					limiting staff.
				</p>
				<div>
					<p className="font-size-md mt-4">Most common technologies:</p>
					<div
						className={classNames(
							styles.list,
							'my-5 d-flex flex-wrap align-items-center'
						)}
					>
						{technologies.map((tech) => (
							<div key={tech.name} className={styles.item}>
								<div className={styles.itemImg}>
									<img src={tech.icon} width={50} height={50} />
								</div>
								<p className="mt-4 font-size-14">{tech.name}</p>
							</div>
						))}
					</div>
				</div>
				<div className="d-flex flex-column flex-xl-row mt-4">
					<div className={styles.applicationList}>
						<h6 className="font-size-md mb-2">Can be applied for:</h6>
						<ul className="font-size-sm">
							{canBeAppliedForData.map((text, index) => (
								<li key={index} className="mb-1">
									<img src={ArrowRight} alt="Arrow right" />
									<span className="ml-2">{text}</span>
								</li>
							))}
						</ul>
					</div>
					<Lottie
						className={classNames(styles.animation, 'mt-4 mt-xl-0')}
						animationData={canBeAppliedForAnimation}
						loop={true}
					/>
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
